import { Stack } from '@mui/material';
import { FunctionComponent } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import StorageExplorer from '../components/StorageExplorer';
import StorageFileType from '../storage/UserRoleType';
import './Home.scss';

interface ExternalHomeProps extends RouteComponentProps {
    progress: Function;
}

const ExternalHome: FunctionComponent<ExternalHomeProps> = (props: ExternalHomeProps) => (
    <div className="ExternalHomeRoot">
        <Stack direction="column" className="ExternalHome">
            <StorageExplorer allowedfilterType={StorageFileType.all} progress={props.progress} {...props} />
        </Stack>
    </div>
);

export default ExternalHome;
